import { lazy } from "react";
import type { ComponentType, LazyExoticComponent } from "react";

import { attemptChunkLoadRecovery } from "./attempt-chunk-load-recovery";

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- mirrors React.lazy's own typing (props variance requires any)
export function lazyWithRecovery<TComponent extends ComponentType<any>>(
  factory: () => Promise<{ default: TComponent }>
): LazyExoticComponent<TComponent> {
  return lazy(async function loadWithRecovery() {
    try {
      return await factory();
    } catch (error) {
      if (attemptChunkLoadRecovery(error)) {
        // Keep the Suspense fallback on screen while the reload happens
        return new Promise<{ default: TComponent }>(function keepSuspenseFallback() {});
      }
      throw error;
    }
  });
}
